import { FETCH_ESAT_SCHEMES, CLEAN_ESAT_SCHEMES, CHANGE_ESAT_SCHEME, DELETE_ESAT_SCHEME } from '../actions/types';
import _ from 'lodash';
import { toNumber } from '../functions';

const ESAT_SCHEMES_DEFAULT_STATE = {};

const EsatSchemesReducer = (state = ESAT_SCHEMES_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_ESAT_SCHEMES:
            return payload;

        case CHANGE_ESAT_SCHEME:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, data: payload.data };
                }

                return item;
            }) };

        case CLEAN_ESAT_SCHEMES:
        case DELETE_ESAT_SCHEME:
            return ESAT_SCHEMES_DEFAULT_STATE;

        default:
            return state;
    }
};

export default EsatSchemesReducer;
